module.exports = __webpack_public_path__ + "img/play.5a484799.svg";